var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.playerIds),function(playerId,index){return _c('span',{key:playerId},[_c('player-link',{attrs:{"lable":"","playerId":playerId}}),(index < _vm.playerIds.length-1)?[_vm._v(", ")]:_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }